export enum ENav {
  DASHBOARD = "DASHBOARD",
  ASSIGNED_ACCOUNT = "ASSIGNED_ACCOUNT",
  MANAGE_TASK = "MANAGE_TASK",
  RECRUITMENT = "RECRUITMENT",
  REPORTS = "REPORTS",
  MEMBERS = "MEMBERS",
  PENDING_REPORT = "PENDING_REPORT",
}

export type TNavChild = Omit<
  TNavItem,
  | "name"
  | "showShowMore"
  | "children"
  | "childrenOpened"
  | "hrefShowMore"
  | "icon"
>;

export type TNavItem = {
  name: ENav;
  label: string;
  href: string;
  icon: React.ReactNode;
  showShowMore?: boolean;
  superAdminOnly?: boolean;
  hrefShowMore?: string;
  children?: TNavChild[];
  childrenOpened?: boolean;
};

export enum ENavTab {
  COMPANY_MATCHING_LIST = "COMPANY_MATCHING_LIST",
  STAFF_MATCHING_LIST = "STAFF_MATCHING_LIST",
  KANBAN_VIEW = "KANBAN_VIEW",
  LIST_VIEW = "LIST_VIEW",
  TODAYS_REPORT = "TODAYS_REPORT",
  EOD_HISTORY = "EOD_HISTORY",
  PENDING_REPORT = "PENDING_REPORT",
}

export type TStaticChildNav = { name: string; slug: string };
